import Api from "./Api";
import { createQueryString } from "./ApiHelper";

export default {
  GetDailyReportList(payload) {
    console.log("GetDailyReportList Payload", payload);
    if (payload && payload.hasOwnProperty("OLD") && payload.OLD) {
      return Api().post("/api/admin/v2.1/getdailysalesreports", payload);
    } else {
      return Api().post("/api/admin/v2/getdailysalesreports", payload);
    }
  },
  GetAggregatorDailyReportList(payload) {
    return Api().post("/api/admin/v2/getaggregatordailysalesreports", payload);
  },
  GetScreenWiseCollectionReport(payload) {
    return Api().post("/api/admin/v2/getscreenwisesalesreports", payload);
  },
  GetFilmWiseCollectionReport(payload) {
    return Api().post("/api/admin/v2/getfilmwisesalesreports", payload);
  },
  GetPerformanceReportList(payload) {
    return Api().post("/api/admin/v2/getperformancereports", payload);
  },
  getPerformanceReportAkil(payload) {
    return Api().post(`/api/admin/v2/getPermofanceReportV3`, payload);
  },
  GetBoxOfficeSummaryReport(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/admin/v2/boxOfficeTransaction${query}`);
  },
  GetBoxOfficeReceiptReport(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/admin/v2/boxOfficeReceipt${query}`);
  },
  GetFnBComboSalesReport(payload) {
    return Api().post(`/api/admin/v2/fnbComboSales`, payload);
  },
  GetRateCardAnalysisReport(payload) {
    return Api().post(`/api/admin/v2/rateCardAnalysis`, payload);
  },
  GetETransactionsReport(payload) {
    return Api().post(`/api/admin/v2/etransactionsreport`, payload);
  },
  GetRefundShowDetail(payload) {
    return Api().post(`/api/admin/v2/refundShowDetails`, payload);
  },
  GetBoxOfficeReceiptSummary(payload) {
    return Api().post(`/api/admin/v2/boxOfficeReceiptSummary`, payload);
  },
  GetClosedShiftSingleDay(payload) {
    return Api().post(`/api/admin/v2/closedShiftsSingleDay`, payload);
  },
  GetHouseKeepingReport(payload) {
    return Api().post(`api/admin/v2/houseKeepingReport`, payload);
  },
  GetSalesRegisterReport(payload) {
    return Api().post(`api/admin/v2/salesRegisterReport`, payload);
  },
  GetSalesRegisterReportMultiple(payload) {
    return Api().post(`api/admin/v2/salesRegisterReport-multiple`, payload);
  },
  GetOnlineBookingsReport(payload) {
    return Api().post(`api/admin/v2/onlineSalesReport`, payload);
  },
  GetRawMaterialSupplierWise(payload) {
    return Api().post(`api/admin/v2/rawMaterialSupplierWiseReport`, payload);
  },
  GetFnBSalesReport(payload) {
    return Api().post(`api/admin/v2/fnbSalesReport`, payload);
  },
  GetFnBSalesExcel(payload) {
    return Api().post(`api/admin/v2/fnbSalesExcel`, payload);
  },
  GetRdrException(payload) {
    return Api().post(`api/admin/v2/rdrExceptionRegister`, payload);
  },
  GetCashierrShiftSummary(payload) {
    return Api().post(`api/admin/v2/cashierShiftSummary`, payload);
  },
  GetFnBPartnerSalesReport(payload) {
    return Api().post(`api/admin/v2/fnbAggregatorSalesReport`, payload);
  },
  GetGcamDetailedReport(payload) {
    return Api().post(`api/admin/v2/detailedGcamReport`, payload);
  },
  GetOccupancySummaryReport(payload) {
    return Api().post(`api/admin/v2/occupancySummaryReport`, payload);
  },
  GetAggregatorSalesNew(payload) {
    return Api().post(`api/admin/v2/get-aggregator-sales-report`, payload);
  },
  GetdailySalesRecordsConcessionV2(payload) {
    return Api().post(
      `/api/admin/v2/getDailySalesRecordsConcessionReports`,
      payload
    );
  },
  GetdailySalesAdvanceRecords(payload) {
    return Api().post(`/api/admin/v2/dailySalesAdvanceSales`, payload);
  },
  getaddonsArray(payload) {
    return Api().post(`/api/admin/v2/getAddonsData`, payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/ReportsService-v2.js